import { State, selectAppPreview } from '../../index'

export const selectDownloadApp = (state: State) => selectAppPreview(state).downloadApp
export const selectDownloadAppFirstStepData = (state: State) => selectDownloadApp(state).step1
export const selectDownloadAppInterpolationListData = (state: State) => selectDownloadApp(state).interpolationListData
